// extracted by mini-css-extract-plugin
export var header = "_si-1";
export var maskBottom = "_si-6";
export var maskMiddle = "_si-7";
export var maskTop = "_si-5";
export var root = "_si-0";
export var scrollDownButton = "_si-3";
export var scrollDownButtonHidden = "_si-4";
export var viewport = "_si-2";